import React from 'react';
import { cn } from '@/lib/utils.ts';

export interface ISVGProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  className?: string;
  glowIntensity?: 'sm' | 'md' | 'lg' | null;
}

export const LoadingSpinner = ({ size = 120, className, glowIntensity = 'md', ...props }: ISVGProps) => {
  const glowClasses = {
    sm: 'drop-shadow-[0_0_2px_currentColor]',
    md: 'drop-shadow-[0_0_4px_currentColor]',
    lg: 'drop-shadow-[0_0_8px_currentColor]',
  };

  return (
    <div
      className={cn(
        'relative flex items-center justify-center',
        glowIntensity && 'animate-pulse before:absolute before:inset-0 before:rounded-full before:bg-current/10 before:blur-lg before:content-[""]',
      )}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        {...props}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={cn('animate-spin', glowIntensity && glowClasses[glowIntensity], className)}
      >
        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
      </svg>
    </div>
  );
};
